// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_examresult,
  add_examresult,
  update_examresult,
  delete_examresult,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    today.setMinutes(today.getMinutes() - offset);
    return today.toISOString().split("T")[0];
  };
const initialState = {
  examresults: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    student: "",
    exam : ""
  },
  filterData: {
    date: getTodayDate()||"",
    exam:"",
    section: "",
    student: "",
    school_class: "",
  },
};


// Async Thunks for API Calls
export const fetchexamresult = createAsyncThunk(
  "examresult/fetchexamresult",
  async (
    { school_id,exam,school_class,
  section,session,student_id, token, signal},
    { rejectWithValue }
  ) => {
    try {
      const response = await get_examresult(  school_id,exam,school_class, section,session,student_id, token, signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createexamresult = createAsyncThunk(
  "examresult/createexamresult",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_examresult(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateexamresult = createAsyncThunk(
  "examresult/updateexamresult",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_examresult(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteexamresult = createAsyncThunk(
  "examresult/deleteexamresult",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_examresult({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const examresultSlice = createSlice({
  name: "examresults",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        date,
        student,
        exam
      } = action.payload;
      state.formData = {
        id,
        date,
        student,
        exam
      };
    },
    resetFormData(state) {
      state.formData = {
        date:getTodayDate()||"",
        student: "",
        exam : ""
      };
    },
    setexamresult(state, action) {
      state.examresults = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
       // Fetch Classes
      .addCase(fetchexamresult.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchexamresult.fulfilled, (state, action) => {
        state.loading = false;
        state.examresults = action.payload;
        console.log("action.payload",action.payload)
      })
      .addCase(fetchexamresult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.examresults = [];

      })

      // Add Class
      .addCase(createexamresult.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createexamresult.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createexamresult.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateexamresult.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateexamresult.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateexamresult.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteexamresult.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteexamresult.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteexamresult.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setexamresult,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = examresultSlice.actions;
export default examresultSlice.reducer;
